
export default {
    file: 'src/content/components/services.json',
    label: 'Teenused/Hinnakiri',
    name: 'services',
    i18n : true,
    fields : [
        {
            label: 'Categories',
            name: 'categories',
            i18n: true,
            widget: 'list',
            fields: [
                {
                    label: 'Name',
                    i18n: true,
                    name: 'name',
                    widget: 'string',
                },
                {
                    label: 'Description',
                    i18n: true,
                    name: 'description',
                    widget: 'text',
                },
                {
                    label: 'Image',
                    name: 'image',
                    widget: 'object',
                    required: true,
                    fields: [
                        {
                            label: 'Image',
                            name: 'image',
                            widget: 'image',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Caption',
                            name: 'caption',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Load Width (px)',
                            name: 'width',
                            widget: 'number',
                            value_type: 'int',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Load Height (px)',
                            name: 'height',
                            widget: 'number',
                            value_type: 'int',
                            i18n: true,
                            required: true,
                        },
                    ]
                },
                {
                    label: 'Services',
                    i18n: true,
                    name: 'services',
                    widget: 'list',
                    fields: [
                        {
                            label: 'Name',
                            i18n: true,
                            name: 'name',
                            widget: 'string',
                        },
                        {
                            label: 'Description',
                            i18n: true,
                            name: 'description',
                            widget: 'string',
                        },
                        {
                            label: 'Price',
                            name: 'price',
                            widget: 'string',
                            i18n: true,
                        },
                    ]
                }
            ],
        },
        {
            label: 'Disclaimer',
            name: 'disclaimer',
            widget: 'text',
            default: '',
            i18n: true,
            required: true,
        }
    ]
}